import React from 'react'
import styled from 'styled-components';
import SlideShow from '../components/SlideShow'

const SlideShowContainer = styled.aside`
  max-width: 600px;
  margin: 2rem auto 0;
`;

const IndexPage = () => (
  <section>
    <h1>Welcome</h1>
    <p>
      Chiropractic has been available in the UK for approximately sixty
      years but is still a relatively new alternative to orthodox medicine.
      In America (the birthplace of chiropractic) this treatment is already
      well established and accepted as a viable form of complimentary
      medicine for the whole family.
    </p>
    <p>
      At Bristol Chiropractor we specialise in the McTimoney Chiropractic
      technique which concentrates on aligning the spine and skeletal
      joints through the means of a gentle low force technique.
    </p>
    <SlideShowContainer>
      <SlideShow />
    </SlideShowContainer>
  </section>
)

export default IndexPage



// WEBPACK FOOTER //
// ./src/pages/index.js